const template = `
	<p class="nm-el-pg nm-el-pg-03">{{=window.i18n['carstore-layer.error-loading-slots']}}</p>
`;
export {template as carstoreFailTemplate};
